export default "__VITE_ASSET__DuoG4s3Q__"